export const postsList = {
  head: "Blog",
  button: "Load More",
  more: "Read more",
};
